import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { PaginationItem } from 'src/app/utils/pagination.utils';
import { SelectComponent } from '../../../../components/select/select.component';
import { TagManagerDirective } from '../../../../directives/tag-manager.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-manutencao-footer',
    templateUrl: './manutencao-footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SelectComponent, TagManagerDirective, NgClass]
})
export class ManutencaoFooterComponent {
  @Input() dados: any;
  @Input() tamanho: string;
  @Input() pagina: number;
  @Input() itensPaginacao: PaginationItem[] = [];
  @Input() tagDropdown: any;
  @Input() tagPagina: any;

  @Output() tamanhoChange = new EventEmitter<string>();
  @Output() alterarPagina = new EventEmitter<any>();
  @Output() alterarTamanho = new EventEmitter<void>();

  readonly opcoesExibicao = [
    { name: 'Exibir 6 por página', value: '6' },
    { name: 'Exibir 9 por página', value: '9' },
    { name: 'Exibir 12 por página', value: '12' }
  ];
}
